module.exports = __webpack_public_path__ + "static/img/6.6215769.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/3/zh/6.png
// module id = Vere
// module chunks = 0